<template>
  <transition name="fade">
    <div v-if="props.show" class="select-auto xl:hidden">
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-[1]"
        @click="modalStore.toggleModal(ModalType.File)"
      />
      <div
        class="absolute inset-0 w-screen h-screen flex items-center justify-center"
      >
        <div
          class="p-3 relative xl:mx-auto my-auto shadow-lg bg-white z-[1] w-screen mx-2 max-h-[80%] overflow-auto"
        >
          <button
            aria-label="Close"
            class="absolute right-0 top-0 py-2 px-3 text-lg text-center "
            @click="modalStore.toggleModal(ModalType.File)"
          >
            <i class="fa fa-times" />
          </button>
          <div class="mb-6">
            <div class="flex justify-center gap-6 mb-4">
              <div>
                <ToolsToolButton
                  icon-class="fa-external-link"
                  label="Grid Size"
                  @click="handleGridSize"
                />
              </div>
              <div>
                <ToolsToolButton
                  :class="{
                    'opacity-75 pointer-events-none': !projectStore.designId,
                  }"
                  icon-class="fa-print"
                  label="Preview"
                  @click="preview"
                />
              </div>
            </div>

            <ul class="flex flex-col text-sm text-center gap-1">
              <li v-if="projectStore.designId" class="xl:font-semibold">
                Design ID:
                <span class="ml-1 select-text font-semibold">{{
                  projectStore.designId
                }}</span>
              </li>
              <li>
                Design Dimensions:
                <span class="ml-1 select-text font-semibold">
                  {{ designSize }}
                </span>
              </li>
              <li>
                Area:
                <span class="ml-1 select-text font-semibold">
                  {{ designArea }}
                </span>
              </li>
            </ul>
          </div>
          <div class="border mb-6 p-6">
            <ToolsProjectTools mobile />
          </div>
          <div class="my-6 text-center">
            <button
              aria-label="View Tiles"
              class="py-2 px-4 bg-black text-white whitespace-nowrap text-sm font-semibold mb-4"
              :class="{ 'opacity-75 pointer-events-none': !myTilesStatus }"
              @click="handleMyTiles"
            >
              View Tiles - {{ myTilesPrice }}
            </button>
            <br />
            <button
              aria-label="Add to cart"
              class="py-2 px-6 bg-[#313358] text-white whitespace-nowrap text-sm font-semibold"
              :class="{ 'opacity-75 pointer-events-none': !myTilesStatus }"
              @click="handleAddToCart"
            >
              Add to cart
            </button>
          </div>

          <div class="grid grid-cols-2 mt-4">
            <div class="text-left">
              <a
                class="bg-transparent border border-black/40 text-black px-2 py-1 text-sm"
                href="https://feltright.com"
              >
                <i class="fal fa-long-arrow-left" />
                Back To Site
              </a>
            </div>

            <div id="tutorial-target" class="text-right">
              <button
                aria-label="Tutorial"
                class="py-1 px-2 border-[#777] bg-[#777] text-sm text-white"
                @click="handleTutorial"
              >
                Tutorial
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ModalType } from "~/stores/modal"

const gridStore = useGridStore();
const modalStore = useModalStore();
const projectStore = useProjectStore();

const { designArea, designSize } = storeToRefs(gridStore);

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const myTiles = gridStore.getTilesList();
const myTilesStatus = myTiles.length > 0;
const myTilesPrice = (() => {
  const totalPrice = myTiles.reduce(
    (acc, tile) => acc + tile.price * tile.quantity,
    0
  );
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalPrice);
})();

const handleMyTiles = () => {
  modalStore.toggleModal(ModalType.MyTiles);
};

const handleAddToCart = async () => {
  await projectStore.addToCart();
};

const handleTutorial = () => {
  modalStore.toggleModal(ModalType.File);
  const event = new Event("mobileTour:start");
  document.dispatchEvent(event);
};

const handleGridSize = () => {
  modalStore.toggleModal(ModalType.GridSize, {
    callback: () => {
      modalStore.toggleModal(ModalType.File)
    }
  });
};

const preview = () => {
  return navigateTo({
    name: "preview-id",
    params: { id: projectStore.designId || 0 },
  });
};
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
